export default __webpack_public_path__ + "static/media/create-and-share.c2900517.jpg";